// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/notebook/v1/document.proto (package chalk.notebook.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { OfflineQueryRequest } from "../../common/v1/offline_query_pb";
import { file_chalk_common_v1_offline_query } from "../../common/v1/offline_query_pb";
import type { GenericSingleQuery } from "../../common/v1/online_query_pb";
import { file_chalk_common_v1_online_query } from "../../common/v1/online_query_pb";
import type { SecretSource } from "../../server/v1/environment_secrets_pb";
import { file_chalk_server_v1_environment_secrets } from "../../server/v1/environment_secrets_pb";
import { file_chalk_utils_v1_sensitive } from "../../utils/v1/sensitive_pb";
import type { Duration, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/notebook/v1/document.proto.
 */
export const file_chalk_notebook_v1_document: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_common_v1_offline_query, file_chalk_common_v1_online_query, file_chalk_server_v1_environment_secrets, file_chalk_utils_v1_sensitive, file_google_protobuf_duration, file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.notebook.v1.NotebookSQLDatasourceRef
 */
export type NotebookSQLDatasourceRef = Message<"chalk.notebook.v1.NotebookSQLDatasourceRef"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string catalog = 3;
   */
  catalog: string;

  /**
   * @generated from field: string schema = 4;
   */
  schema: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookSQLDatasourceRef.
 * Use `create(NotebookSQLDatasourceRefSchema)` to create a new message.
 */
export const NotebookSQLDatasourceRefSchema: GenMessage<NotebookSQLDatasourceRef> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document, 0);

/**
 * Reference to an already-built custom kernel image for a notebook. A notebook
 * custom image is NOT an arbitrary FROM image: the kernel container's
 * entrypoint is chalk_nb_server, so a custom image is the pinned chalk_nb_server
 * base image plus the user's layers (pip/uv/apt installs). The backend enforces
 * this by setting the ImageSpec's base image to the server's chalk_nb_server
 * runtime image and appending the user's build steps on top. This ref points at
 * the resulting content-addressed build in the environment's custom_image_refs
 * index; the full ImageSpec (for re-editing) is fetched from CustomImageService
 * by content_hash on demand.
 *
 * @generated from message chalk.notebook.v1.NotebookImageRef
 */
export type NotebookImageRef = Message<"chalk.notebook.v1.NotebookImageRef"> & {
  /**
   * Content-addressed hash identifying the build (the custom_image_refs dedup
   * key). Resolved to a concrete image_ref at provision time.
   *
   * @generated from field: string content_hash = 1;
   */
  contentHash: string;

  /**
   * Backend build handle (e.g. Argo workflow name), if known. Advisory; the
   * content_hash is the authoritative lookup key.
   *
   * @generated from field: string build_id = 2;
   */
  buildId: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookImageRef.
 * Use `create(NotebookImageRefSchema)` to create a new message.
 */
export const NotebookImageRefSchema: GenMessage<NotebookImageRef> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document, 1);

/**
 * @generated from message chalk.notebook.v1.NotebookDocumentDefaults
 */
export type NotebookDocumentDefaults = Message<"chalk.notebook.v1.NotebookDocumentDefaults"> & {
  /**
   * @generated from field: chalk.notebook.v1.NotebookSQLDatasourceRef sql_datasource = 1;
   */
  sqlDatasource?: NotebookSQLDatasourceRef;

  /**
   * @generated from field: optional string resource_group = 2;
   */
  resourceGroup?: string;

  /**
   * Kernel container compute tier (maps to ResourceLimits at provision time).
   *
   * @generated from field: chalk.notebook.v1.NotebookComputePreset compute_preset = 3;
   */
  computePreset: NotebookComputePreset;

  /**
   * Auto-suspend the kernel after this many seconds idle. Absent -> server
   * default (3600); 0 -> indefinite (never auto-suspend); >0 -> that many
   * seconds. The idle-suspend reaper enforces it.
   *
   * @generated from field: optional int32 idle_timeout_seconds = 4;
   */
  idleTimeoutSeconds?: number;

  /**
   * IANA timezone (e.g. "America/New_York") used to render timestamps in this
   * notebook's UI. Empty falls back to the viewer's local/UTC default.
   *
   * @generated from field: optional string timezone = 5;
   */
  timezone?: string;

  /**
   * Optional custom kernel image for this notebook. When set and resolvable,
   * the kernel container is provisioned from the referenced custom image
   * (chalk_nb_server base + user layers) instead of the server default runtime
   * image. Absent or unresolvable -> the default runtime image (never wedges).
   *
   * @generated from field: optional chalk.notebook.v1.NotebookImageRef image = 7;
   */
  image?: NotebookImageRef;

  /**
   * Notebook-level default max staleness for SQL result caching. Absent =
   * inherit from environment/team settings. 0 = caching off for this notebook.
   *
   * @generated from field: optional google.protobuf.Duration sql_max_staleness = 8;
   */
  sqlMaxStaleness?: Duration;
};

/**
 * Describes the message chalk.notebook.v1.NotebookDocumentDefaults.
 * Use `create(NotebookDocumentDefaultsSchema)` to create a new message.
 */
export const NotebookDocumentDefaultsSchema: GenMessage<NotebookDocumentDefaults> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document, 2);

/**
 * @generated from message chalk.notebook.v1.NotebookPythonExecutionOptions
 */
export type NotebookPythonExecutionOptions = Message<"chalk.notebook.v1.NotebookPythonExecutionOptions"> & {
  /**
   * @generated from field: optional string resource_group = 1;
   */
  resourceGroup?: string;

  /**
   * Wall-clock limit for one execution of this cell. Unset or zero falls back
   * to the server default; the server clamps to its configured maximum.
   *
   * @generated from field: optional int32 timeout_seconds = 2;
   */
  timeoutSeconds?: number;
};

/**
 * Describes the message chalk.notebook.v1.NotebookPythonExecutionOptions.
 * Use `create(NotebookPythonExecutionOptionsSchema)` to create a new message.
 */
export const NotebookPythonExecutionOptionsSchema: GenMessage<NotebookPythonExecutionOptions> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document, 3);

/**
 * @generated from message chalk.notebook.v1.NotebookSQLExecutionOptions
 */
export type NotebookSQLExecutionOptions = Message<"chalk.notebook.v1.NotebookSQLExecutionOptions"> & {
  /**
   * @generated from field: optional string resource_group = 1;
   */
  resourceGroup?: string;

  /**
   * @generated from field: chalk.notebook.v1.NotebookSQLExecutionMode execution_mode = 2;
   */
  executionMode: NotebookSQLExecutionMode;

  /**
   * @generated from field: optional int64 max_memory_bytes = 3;
   */
  maxMemoryBytes?: bigint;

  /**
   * @generated from field: bool persist_results = 4;
   */
  persistResults: boolean;

  /**
   * @generated from field: bool generate_performance_summary = 5;
   */
  generatePerformanceSummary: boolean;

  /**
   * Per-cell cache opinion: reuse this cell's prior result if it is younger
   * than this. 0 = always execute fresh (never serve from cache). Absent =
   * inherit (notebook -> environment -> team -> server default). Deliberately
   * excluded from the cache fingerprint so tuning it never busts the cache.
   *
   * @generated from field: optional google.protobuf.Duration max_staleness = 6;
   */
  maxStaleness?: Duration;
};

/**
 * Describes the message chalk.notebook.v1.NotebookSQLExecutionOptions.
 * Use `create(NotebookSQLExecutionOptionsSchema)` to create a new message.
 */
export const NotebookSQLExecutionOptionsSchema: GenMessage<NotebookSQLExecutionOptions> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document, 4);

/**
 * @generated from message chalk.notebook.v1.NotebookPythonCell
 */
export type NotebookPythonCell = Message<"chalk.notebook.v1.NotebookPythonCell"> & {
  /**
   * @generated from field: string source = 1;
   */
  source: string;

  /**
   * @generated from field: optional string result_variable_name = 2;
   */
  resultVariableName?: string;

  /**
   * @generated from field: chalk.notebook.v1.NotebookPythonExecutionOptions execution_options = 3;
   */
  executionOptions?: NotebookPythonExecutionOptions;
};

/**
 * Describes the message chalk.notebook.v1.NotebookPythonCell.
 * Use `create(NotebookPythonCellSchema)` to create a new message.
 */
export const NotebookPythonCellSchema: GenMessage<NotebookPythonCell> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document, 5);

/**
 * @generated from message chalk.notebook.v1.NotebookSQLCell
 */
export type NotebookSQLCell = Message<"chalk.notebook.v1.NotebookSQLCell"> & {
  /**
   * @generated from field: string source = 1;
   */
  source: string;

  /**
   * @generated from field: chalk.notebook.v1.NotebookSQLDatasourceRef sql_datasource = 2;
   */
  sqlDatasource?: NotebookSQLDatasourceRef;

  /**
   * @generated from field: optional string result_variable_name = 3;
   */
  resultVariableName?: string;

  /**
   * @generated from field: chalk.notebook.v1.NotebookSQLExecutionOptions execution_options = 4;
   */
  executionOptions?: NotebookSQLExecutionOptions;
};

/**
 * Describes the message chalk.notebook.v1.NotebookSQLCell.
 * Use `create(NotebookSQLCellSchema)` to create a new message.
 */
export const NotebookSQLCellSchema: GenMessage<NotebookSQLCell> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document, 6);

/**
 * @generated from message chalk.notebook.v1.NotebookTextCell
 */
export type NotebookTextCell = Message<"chalk.notebook.v1.NotebookTextCell"> & {
  /**
   * @generated from field: string source = 1;
   */
  source: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookTextCell.
 * Use `create(NotebookTextCellSchema)` to create a new message.
 */
export const NotebookTextCellSchema: GenMessage<NotebookTextCell> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document, 7);

/**
 * @generated from message chalk.notebook.v1.NotebookMarkdownCell
 */
export type NotebookMarkdownCell = Message<"chalk.notebook.v1.NotebookMarkdownCell"> & {
  /**
   * @generated from field: string source = 1;
   */
  source: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookMarkdownCell.
 * Use `create(NotebookMarkdownCellSchema)` to create a new message.
 */
export const NotebookMarkdownCellSchema: GenMessage<NotebookMarkdownCell> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document, 8);

/**
 * An interactive parameter element. Input cells are not executed; before
 * every python cell run, each input's current value is bound to its variable
 * name in the kernel globals (text -> str, number -> float, checkbox -> bool,
 * date -> datetime.date, select -> str, multiselect -> list[str]).
 *
 * @generated from message chalk.notebook.v1.NotebookInputCell
 */
export type NotebookInputCell = Message<"chalk.notebook.v1.NotebookInputCell"> & {
  /**
   * @generated from field: chalk.notebook.v1.NotebookInputKind kind = 1;
   */
  kind: NotebookInputKind;

  /**
   * Python global the value is bound to; displayed as a variable pill under
   * the control, like python cell result variables.
   *
   * @generated from field: optional string result_variable_name = 2;
   */
  resultVariableName?: string;

  /**
   * Display label shown above the control.
   *
   * @generated from field: string label = 3;
   */
  label: string;

  /**
   * Static choices for SELECT/MULTISELECT.
   *
   * @generated from field: repeated string options = 4;
   */
  options: string[];

  /**
   * Whether SELECT allows clearing back to no selection.
   *
   * @generated from field: bool allow_clear = 5;
   */
  allowClear: boolean;

  /**
   * How SELECT/MULTISELECT choices are sourced: static `options` (the
   * default) or a dataframe variable in kernel scope.
   *
   * @generated from field: chalk.notebook.v1.NotebookInputValuesMode values_mode = 6;
   */
  valuesMode: NotebookInputValuesMode;

  /**
   * DYNAMIC mode: kernel variable holding an Arrow-backed dataframe.
   *
   * @generated from field: optional string dynamic_values_variable = 7;
   */
  dynamicValuesVariable?: string;

  /**
   * DYNAMIC mode: column whose values become the option values.
   *
   * @generated from field: optional string dynamic_value_column = 8;
   */
  dynamicValueColumn?: string;

  /**
   * DYNAMIC mode: column shown as the option label; falls back to the value
   * column when unset.
   *
   * @generated from field: optional string dynamic_display_column = 9;
   */
  dynamicDisplayColumn?: string;

  /**
   * Current value; the populated field must match `kind`.
   *
   * @generated from field: optional string text_value = 10;
   */
  textValue?: string;

  /**
   * @generated from field: optional double number_value = 11;
   */
  numberValue?: number;

  /**
   * @generated from field: optional bool checkbox_value = 12;
   */
  checkboxValue?: boolean;

  /**
   * ISO-8601 calendar date (YYYY-MM-DD).
   *
   * @generated from field: optional string date_value = 13;
   */
  dateValue?: string;

  /**
   * SELECT uses element 0; MULTISELECT uses all elements.
   *
   * @generated from field: repeated string selected_options = 14;
   */
  selectedOptions: string[];

  /**
   * SINGLE_VALUE display element (kind = SINGLE_VALUE): the value is derived
   * client-side from a kernel variable; `label` doubles as the caption shown
   * under the value. The value fields above and the binding fields
   * (result_variable_name) are unused for this kind.
   * Kernel variable the value is read from (a scalar or a dataframe).
   *
   * @generated from field: optional string single_value_variable = 15;
   */
  singleValueVariable?: string;

  /**
   * Dataframe variables: column the value/aggregate is taken from.
   *
   * @generated from field: optional string single_value_column = 16;
   */
  singleValueColumn?: string;

  /**
   * Dataframe variables: whether one row or an aggregate is shown.
   *
   * @generated from field: chalk.notebook.v1.NotebookSingleValueSelector single_value_selector = 17;
   */
  singleValueSelector: NotebookSingleValueSelector;

  /**
   * SELECTOR_ROW: row index; negative counts from the end (python-style).
   *
   * @generated from field: int64 single_value_row = 18;
   */
  singleValueRow: bigint;

  /**
   * @generated from field: chalk.notebook.v1.NotebookSingleValueAggregation single_value_aggregation = 19;
   */
  singleValueAggregation: NotebookSingleValueAggregation;

  /**
   * SECTION cells: title typography (`label` carries the title).
   *
   * @generated from field: chalk.notebook.v1.NotebookSectionHeadingSize section_heading_size = 20;
   */
  sectionHeadingSize: NotebookSectionHeadingSize;

  /**
   * Caption under the control, editable in place (TOGGLE/CHECKBOX today).
   *
   * @generated from field: optional string description = 21;
   */
  description?: string;

  /**
   * SINGLE_VALUE display format id, from the frontend's shared column-format
   * menu (e.g. "currency", "relative-time"). Kept as a string so the format
   * list stays frontend-owned; unset/unknown values render as "automatic".
   *
   * @generated from field: optional string single_value_format = 22;
   */
  singleValueFormat?: string;

  /**
   * Legacy TABLE input cells (kind = TABLE): superseded by the first-class
   * NotebookTableCell body case. Readers map these fields forward; writers
   * never emit them.
   *
   * @generated from field: chalk.notebook.v1.NotebookTableSourceKind table_source_kind = 23;
   */
  tableSourceKind: NotebookTableSourceKind;

  /**
   * @generated from field: optional string table_variable = 24;
   */
  tableVariable?: string;

  /**
   * @generated from field: optional string table_dataset_name = 25;
   */
  tableDatasetName?: string;

  /**
   * @generated from field: optional string table_dataset_revision_id = 26;
   */
  tableDatasetRevisionId?: string;

  /**
   * @generated from field: optional string table_sql_datasource = 27;
   */
  tableSqlDatasource?: string;

  /**
   * @generated from field: optional string table_sql_catalog = 28;
   */
  tableSqlCatalog?: string;

  /**
   * @generated from field: optional string table_sql_schema = 29;
   */
  tableSqlSchema?: string;

  /**
   * @generated from field: optional string table_sql_table = 30;
   */
  tableSqlTable?: string;

  /**
   * DATA_TABLE inputs: the user-entered literal grid. Column order is the
   * display order; every row holds one string per column (cells are
   * free-form text).
   *
   * @generated from field: repeated chalk.notebook.v1.NotebookDataTableColumn data_table_columns = 31;
   */
  dataTableColumns: NotebookDataTableColumn[];

  /**
   * @generated from field: repeated chalk.notebook.v1.NotebookDataTableRow data_table_rows = 32;
   */
  dataTableRows: NotebookDataTableRow[];

  /**
   * AGGREGATION_PERCENTILE: the percentile rank in 0-100 (95 for p95). Unset
   * for every other aggregation.
   *
   * @generated from field: optional double single_value_percentile = 33;
   */
  singleValuePercentile?: number;
};

/**
 * Describes the message chalk.notebook.v1.NotebookInputCell.
 * Use `create(NotebookInputCellSchema)` to create a new message.
 */
export const NotebookInputCellSchema: GenMessage<NotebookInputCell> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document, 9);

/**
 * DATA_TABLE inputs: one user-defined column of the literal grid.
 *
 * @generated from message chalk.notebook.v1.NotebookDataTableColumn
 */
export type NotebookDataTableColumn = Message<"chalk.notebook.v1.NotebookDataTableColumn"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookDataTableColumn.
 * Use `create(NotebookDataTableColumnSchema)` to create a new message.
 */
export const NotebookDataTableColumnSchema: GenMessage<NotebookDataTableColumn> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document, 10);

/**
 * DATA_TABLE inputs: one row of the literal grid; values align positionally
 * with NotebookInputCell.data_table_columns.
 *
 * @generated from message chalk.notebook.v1.NotebookDataTableRow
 */
export type NotebookDataTableRow = Message<"chalk.notebook.v1.NotebookDataTableRow"> & {
  /**
   * @generated from field: repeated string values = 1;
   */
  values: string[];
};

/**
 * Describes the message chalk.notebook.v1.NotebookDataTableRow.
 * Use `create(NotebookDataTableRowSchema)` to create a new message.
 */
export const NotebookDataTableRowSchema: GenMessage<NotebookDataTableRow> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document, 11);

/**
 * Kernel variable holding an Arrow-backed dataframe.
 *
 * @generated from message chalk.notebook.v1.NotebookTableVariableSource
 */
export type NotebookTableVariableSource = Message<"chalk.notebook.v1.NotebookTableVariableSource"> & {
  /**
   * @generated from field: string variable = 1;
   */
  variable: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookTableVariableSource.
 * Use `create(NotebookTableVariableSourceSchema)` to create a new message.
 */
export const NotebookTableVariableSourceSchema: GenMessage<NotebookTableVariableSource> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document, 12);

/**
 * Chalk dataset: display name plus the revision the preview reads from
 * (GetDatasetRevisionPreview keys on revision id).
 *
 * @generated from message chalk.notebook.v1.NotebookTableDatasetSource
 */
export type NotebookTableDatasetSource = Message<"chalk.notebook.v1.NotebookTableDatasetSource"> & {
  /**
   * @generated from field: string dataset_name = 1;
   */
  datasetName: string;

  /**
   * @generated from field: string revision_id = 2;
   */
  revisionId: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookTableDatasetSource.
 * Use `create(NotebookTableDatasetSourceSchema)` to create a new message.
 */
export const NotebookTableDatasetSourceSchema: GenMessage<NotebookTableDatasetSource> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document, 13);

/**
 * Fully-qualified table identity within a configured SQL datasource
 * (catalog/schema may be empty for sources without that level).
 *
 * @generated from message chalk.notebook.v1.NotebookTableSqlTableSource
 */
export type NotebookTableSqlTableSource = Message<"chalk.notebook.v1.NotebookTableSqlTableSource"> & {
  /**
   * @generated from field: string datasource = 1;
   */
  datasource: string;

  /**
   * @generated from field: string catalog = 2;
   */
  catalog: string;

  /**
   * @generated from field: string db_schema = 3;
   */
  dbSchema: string;

  /**
   * @generated from field: string table = 4;
   */
  table: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookTableSqlTableSource.
 * Use `create(NotebookTableSqlTableSourceSchema)` to create a new message.
 */
export const NotebookTableSqlTableSourceSchema: GenMessage<NotebookTableSqlTableSource> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document, 14);

/**
 * Display-only cell rendering a dataframe as a full-width table. Never
 * executed and never bound into the kernel; resolved client-side.
 *
 * @generated from message chalk.notebook.v1.NotebookTableCell
 */
export type NotebookTableCell = Message<"chalk.notebook.v1.NotebookTableCell"> & {
  /**
   * Where the rows come from; unset renders the cell's empty "choose a data
   * source" state.
   *
   * @generated from oneof chalk.notebook.v1.NotebookTableCell.source
   */
  source: {
    /**
     * @generated from field: chalk.notebook.v1.NotebookTableVariableSource variable = 1;
     */
    value: NotebookTableVariableSource;
    case: "variable";
  } | {
    /**
     * @generated from field: chalk.notebook.v1.NotebookTableDatasetSource dataset = 2;
     */
    value: NotebookTableDatasetSource;
    case: "dataset";
  } | {
    /**
     * @generated from field: chalk.notebook.v1.NotebookTableSqlTableSource sql_table = 3;
     */
    value: NotebookTableSqlTableSource;
    case: "sqlTable";
  } | { case: undefined; value?: undefined };

  /**
   * Caption shown under the table.
   *
   * @generated from field: string label = 4;
   */
  label: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookTableCell.
 * Use `create(NotebookTableCellSchema)` to create a new message.
 */
export const NotebookTableCellSchema: GenMessage<NotebookTableCell> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document, 15);

/**
 * @generated from message chalk.notebook.v1.NotebookOnlineQueryCell
 */
export type NotebookOnlineQueryCell = Message<"chalk.notebook.v1.NotebookOnlineQueryCell"> & {
  /**
   * @generated from field: chalk.common.v1.GenericSingleQuery query = 1;
   */
  query?: GenericSingleQuery;

  /**
   * @generated from field: optional string result_variable_name = 2;
   */
  resultVariableName?: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookOnlineQueryCell.
 * Use `create(NotebookOnlineQueryCellSchema)` to create a new message.
 */
export const NotebookOnlineQueryCellSchema: GenMessage<NotebookOnlineQueryCell> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document, 16);

/**
 * @generated from message chalk.notebook.v1.NotebookOfflineQueryCell
 */
export type NotebookOfflineQueryCell = Message<"chalk.notebook.v1.NotebookOfflineQueryCell"> & {
  /**
   * @generated from field: chalk.common.v1.OfflineQueryRequest query = 1;
   */
  query?: OfflineQueryRequest;

  /**
   * @generated from field: optional string result_variable_name = 2;
   */
  resultVariableName?: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookOfflineQueryCell.
 * Use `create(NotebookOfflineQueryCellSchema)` to create a new message.
 */
export const NotebookOfflineQueryCellSchema: GenMessage<NotebookOfflineQueryCell> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document, 17);

/**
 * @generated from message chalk.notebook.v1.NotebookCellViewState
 */
export type NotebookCellViewState = Message<"chalk.notebook.v1.NotebookCellViewState"> & {
  /**
   * @generated from field: bool source_collapsed = 1;
   */
  sourceCollapsed: boolean;

  /**
   * @generated from field: bool result_collapsed = 2;
   */
  resultCollapsed: boolean;

  /**
   * @generated from field: optional int32 result_height_px = 3;
   */
  resultHeightPx?: number;
};

/**
 * Describes the message chalk.notebook.v1.NotebookCellViewState.
 * Use `create(NotebookCellViewStateSchema)` to create a new message.
 */
export const NotebookCellViewStateSchema: GenMessage<NotebookCellViewState> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document, 18);

/**
 * A grouping over cells, referenced by NotebookCell.group_id. Cells keep
 * their single flat document order; a ROW group manifests as the maximal run
 * of ADJACENT cells sharing the group id (non-adjacent members render as
 * ordinary cells). Future grouping kinds (e.g. titled sections) extend the
 * kind enum and use the same membership model.
 *
 * @generated from message chalk.notebook.v1.NotebookCellGroup
 */
export type NotebookCellGroup = Message<"chalk.notebook.v1.NotebookCellGroup"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: chalk.notebook.v1.NotebookCellGroupKind kind = 2;
   */
  kind: NotebookCellGroupKind;

  /**
   * Display title for future grouping kinds (e.g. sections); unused for ROW.
   *
   * @generated from field: string title = 3;
   */
  title: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookCellGroup.
 * Use `create(NotebookCellGroupSchema)` to create a new message.
 */
export const NotebookCellGroupSchema: GenMessage<NotebookCellGroup> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document, 19);

/**
 * @generated from message chalk.notebook.v1.NotebookCell
 */
export type NotebookCell = Message<"chalk.notebook.v1.NotebookCell"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: chalk.notebook.v1.NotebookCellViewState view_state = 3;
   */
  viewState?: NotebookCellViewState;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string created_by = 6;
   */
  createdBy: string;

  /**
   * @generated from field: string updated_by = 7;
   */
  updatedBy: string;

  /**
   * @generated from field: string revision_id = 8;
   */
  revisionId: string;

  /**
   * Membership in a NotebookDocument.cell_groups entry; absent for ungrouped
   * cells (normal full-width flow).
   *
   * @generated from field: optional string group_id = 9;
   */
  groupId?: string;

  /**
   * Membership in a section: the id of the SECTION input cell this cell
   * belongs to. Orthogonal to group_id, so a row can live inside a section.
   * Like rows, membership manifests only while the member sits contiguously
   * after its section header in the flat cell order.
   *
   * @generated from field: optional string section_id = 10;
   */
  sectionId?: string;

  /**
   * @generated from oneof chalk.notebook.v1.NotebookCell.body
   */
  body: {
    /**
     * @generated from field: chalk.notebook.v1.NotebookPythonCell python = 20;
     */
    value: NotebookPythonCell;
    case: "python";
  } | {
    /**
     * @generated from field: chalk.notebook.v1.NotebookSQLCell sql = 21;
     */
    value: NotebookSQLCell;
    case: "sql";
  } | {
    /**
     * @generated from field: chalk.notebook.v1.NotebookTextCell text = 22;
     */
    value: NotebookTextCell;
    case: "text";
  } | {
    /**
     * @generated from field: chalk.notebook.v1.NotebookMarkdownCell markdown = 23;
     */
    value: NotebookMarkdownCell;
    case: "markdown";
  } | {
    /**
     * @generated from field: chalk.notebook.v1.NotebookOnlineQueryCell online_query = 24;
     */
    value: NotebookOnlineQueryCell;
    case: "onlineQuery";
  } | {
    /**
     * @generated from field: chalk.notebook.v1.NotebookOfflineQueryCell offline_query = 25;
     */
    value: NotebookOfflineQueryCell;
    case: "offlineQuery";
  } | {
    /**
     * @generated from field: chalk.notebook.v1.NotebookInputCell input = 26;
     */
    value: NotebookInputCell;
    case: "input";
  } | {
    /**
     * @generated from field: chalk.notebook.v1.NotebookTableCell table = 27;
     */
    value: NotebookTableCell;
    case: "table";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.notebook.v1.NotebookCell.
 * Use `create(NotebookCellSchema)` to create a new message.
 */
export const NotebookCellSchema: GenMessage<NotebookCell> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document, 20);

/**
 * @generated from message chalk.notebook.v1.NotebookDocument
 */
export type NotebookDocument = Message<"chalk.notebook.v1.NotebookDocument"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string project_id = 2;
   */
  projectId: string;

  /**
   * @generated from field: string environment_id = 3;
   */
  environmentId: string;

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * @generated from field: repeated string categories = 7;
   */
  categories: string[];

  /**
   * @generated from field: repeated chalk.notebook.v1.NotebookCell cells = 8;
   */
  cells: NotebookCell[];

  /**
   * @generated from field: chalk.notebook.v1.NotebookDocumentDefaults defaults = 9;
   */
  defaults?: NotebookDocumentDefaults;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string created_by = 12;
   */
  createdBy: string;

  /**
   * @generated from field: string updated_by = 13;
   */
  updatedBy: string;

  /**
   * @generated from field: string revision_id = 14;
   */
  revisionId: string;

  /**
   * Set when the notebook has been archived. Archived notebooks are excluded
   * from the default list view (see ListNotebookDocumentsRequest.include_archived)
   * but are not soft-deleted; clearing this field restores the notebook. Absent
   * (null) means the notebook is active.
   *
   * @generated from field: google.protobuf.Timestamp archived_at = 16;
   */
  archivedAt?: Timestamp;

  /**
   * Total number of opens across all users for this notebook. Populated on
   * single-get and list responses via a left-join view aggregate (0 when never
   * viewed).
   *
   * @generated from field: int64 total_view_count = 17;
   */
  totalViewCount: bigint;

  /**
   * The requesting user's most recent open of this notebook. Absent (null) when
   * this user has never opened it.
   *
   * @generated from field: google.protobuf.Timestamp viewer_last_viewed_at = 18;
   */
  viewerLastViewedAt?: Timestamp;

  /**
   * Cell groupings referenced by NotebookCell.group_id (rows today; future
   * grouping kinds reuse this registry).
   *
   * @generated from field: repeated chalk.notebook.v1.NotebookCellGroup cell_groups = 19;
   */
  cellGroups: NotebookCellGroup[];

  /**
   * Id of the chalk.artifacts.v1.Dashboard row backing this notebook's app
   * view. On the live document this is the mutable layout
   * (owner_type="notebook", owner_id=this document's id), server-set via
   * EnsureNotebookApp and absent until the app is first created. On a
   * historical read (GetNotebookDocument with revision_id) it is instead that
   * revision's immutable layout snapshot (owner_type="notebook_version"), or
   * absent for revisions predating the app. A soft string ref by design:
   * layout persistence stays with the dashboard service.
   *
   * @generated from field: optional string app_dashboard_id = 20;
   */
  appDashboardId?: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookDocument.
 * Use `create(NotebookDocumentSchema)` to create a new message.
 */
export const NotebookDocumentSchema: GenMessage<NotebookDocument> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document, 21);

/**
 * Metadata for one persisted document revision. Revision content is fetched
 * via GetNotebookDocument with revision_id set.
 *
 * @generated from message chalk.notebook.v1.NotebookDocumentRevision
 */
export type NotebookDocumentRevision = Message<"chalk.notebook.v1.NotebookDocumentRevision"> & {
  /**
   * @generated from field: string revision_id = 1;
   */
  revisionId: string;

  /**
   * @generated from field: string notebook_id = 2;
   */
  notebookId: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: int32 cell_count = 4;
   */
  cellCount: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 6;
   */
  createdBy: string;

  /**
   * App-layout snapshot as of this revision: id of an immutable Dashboard row
   * (owner_type="notebook_version"). Revisions whose layout did not change
   * share their predecessor's snapshot row. Absent for revisions that predate
   * the notebook's app.
   *
   * @generated from field: optional string app_dashboard_id = 7;
   */
  appDashboardId?: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookDocumentRevision.
 * Use `create(NotebookDocumentRevisionSchema)` to create a new message.
 */
export const NotebookDocumentRevisionSchema: GenMessage<NotebookDocumentRevision> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document, 22);

/**
 * A revocable link granting read-only access to exactly one notebook.
 *
 * The row id is public; the secret is a token shown exactly once, at creation,
 * and persisted only as a hash. `require_authentication` decides whether
 * holding the token is sufficient (false -- the token alone is the capability,
 * like a signed URL) or whether the viewer must additionally be a signed-in
 * member of the owning team (true).
 *
 * @generated from message chalk.notebook.v1.NotebookShareLink
 */
export type NotebookShareLink = Message<"chalk.notebook.v1.NotebookShareLink"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string notebook_id = 2;
   */
  notebookId: string;

  /**
   * @generated from field: string environment_id = 3;
   */
  environmentId: string;

  /**
   * Human-readable label chosen at creation, so links can be told apart when
   * deciding which to revoke.
   *
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * When false the link is public and serves anyone holding the token.
   *
   * @generated from field: bool require_authentication = 5;
   */
  requireAuthentication: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 7;
   */
  createdBy: string;

  /**
   * Absent when the link does not expire.
   *
   * @generated from field: optional google.protobuf.Timestamp expires_at = 8;
   */
  expiresAt?: Timestamp;

  /**
   * Set once revoked; a revoked link is never accepted again.
   *
   * @generated from field: optional google.protobuf.Timestamp revoked_at = 9;
   */
  revokedAt?: Timestamp;

  /**
   * Most recent successful use. Absent until the link is first opened.
   *
   * @generated from field: optional google.protobuf.Timestamp last_accessed_at = 10;
   */
  lastAccessedAt?: Timestamp;

  /**
   * The shareable URL, which embeds the secret token. Populated ONLY in
   * CreateNotebookShareLinkResponse -- list responses leave it empty, because
   * the server keeps only a hash and cannot reconstruct it.
   *
   * @generated from field: string url = 11;
   */
  url: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookShareLink.
 * Use `create(NotebookShareLinkSchema)` to create a new message.
 */
export const NotebookShareLinkSchema: GenMessage<NotebookShareLink> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document, 23);

/**
 * @generated from message chalk.notebook.v1.NotebookSecret
 */
export type NotebookSecret = Message<"chalk.notebook.v1.NotebookSecret"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string notebook_id = 2;
   */
  notebookId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: chalk.server.v1.SecretSource source = 4;
   */
  source: SecretSource;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: chalk.notebook.v1.NotebookSecretOrigin origin = 6;
   */
  origin: NotebookSecretOrigin;
};

/**
 * Describes the message chalk.notebook.v1.NotebookSecret.
 * Use `create(NotebookSecretSchema)` to create a new message.
 */
export const NotebookSecretSchema: GenMessage<NotebookSecret> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document, 24);

/**
 * @generated from message chalk.notebook.v1.NotebookSecretValue
 */
export type NotebookSecretValue = Message<"chalk.notebook.v1.NotebookSecretValue"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;

  /**
   * @generated from field: chalk.server.v1.SecretSource source = 3;
   */
  source: SecretSource;
};

/**
 * Describes the message chalk.notebook.v1.NotebookSecretValue.
 * Use `create(NotebookSecretValueSchema)` to create a new message.
 */
export const NotebookSecretValueSchema: GenMessage<NotebookSecretValue> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document, 25);

/**
 * @generated from enum chalk.notebook.v1.NotebookCellExecutionStatus
 */
export enum NotebookCellExecutionStatus {
  /**
   * @generated from enum value: NOTEBOOK_CELL_EXECUTION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTEBOOK_CELL_EXECUTION_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: NOTEBOOK_CELL_EXECUTION_STATUS_RUNNING = 2;
   */
  RUNNING = 2,

  /**
   * @generated from enum value: NOTEBOOK_CELL_EXECUTION_STATUS_SUCCESS = 3;
   */
  SUCCESS = 3,

  /**
   * @generated from enum value: NOTEBOOK_CELL_EXECUTION_STATUS_ERROR = 4;
   */
  ERROR = 4,

  /**
   * @generated from enum value: NOTEBOOK_CELL_EXECUTION_STATUS_CANCELED = 5;
   */
  CANCELED = 5,

  /**
   * @generated from enum value: NOTEBOOK_CELL_EXECUTION_STATUS_STALE = 6;
   */
  STALE = 6,
}

/**
 * Describes the enum chalk.notebook.v1.NotebookCellExecutionStatus.
 */
export const NotebookCellExecutionStatusSchema: GenEnum<NotebookCellExecutionStatus> = /*@__PURE__*/
  enumDesc(file_chalk_notebook_v1_document, 0);

/**
 * @generated from enum chalk.notebook.v1.NotebookRunScope
 */
export enum NotebookRunScope {
  /**
   * @generated from enum value: NOTEBOOK_RUN_SCOPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTEBOOK_RUN_SCOPE_AUTO = 1;
   */
  AUTO = 1,

  /**
   * @generated from enum value: NOTEBOOK_RUN_SCOPE_CELL_ONLY = 2;
   */
  CELL_ONLY = 2,

  /**
   * @generated from enum value: NOTEBOOK_RUN_SCOPE_CELL_AND_UPSTREAM = 3;
   */
  CELL_AND_UPSTREAM = 3,

  /**
   * @generated from enum value: NOTEBOOK_RUN_SCOPE_CELL_AND_DOWNSTREAM = 4;
   */
  CELL_AND_DOWNSTREAM = 4,
}

/**
 * Describes the enum chalk.notebook.v1.NotebookRunScope.
 */
export const NotebookRunScopeSchema: GenEnum<NotebookRunScope> = /*@__PURE__*/
  enumDesc(file_chalk_notebook_v1_document, 1);

/**
 * Named compute tier for the notebook's kernel container. Each preset maps to a
 * fixed ResourceLimits (cpu/memory) server-side; UNSPECIFIED uses the server
 * default. Notebook kernels run as Chalk containers (not query resource
 * groups), so sizing is the container's ResourceLimits, not a routing label.
 *
 * @generated from enum chalk.notebook.v1.NotebookComputePreset
 */
export enum NotebookComputePreset {
  /**
   * @generated from enum value: NOTEBOOK_COMPUTE_PRESET_UNSPECIFIED = 0;
   */
  NOTEBOOK_COMPUTE_PRESET_UNSPECIFIED = 0,

  /**
   * Existing values 1-3 are persisted in notebook_documents.defaults blobs; do
   * NOT renumber them. New tiers are appended with new numbers. Declaration
   * order is irrelevant to the wire; the frontend controls display order.
   *
   * @generated from enum value: NOTEBOOK_COMPUTE_PRESET_SMALL = 1;
   */
  NOTEBOOK_COMPUTE_PRESET_SMALL = 1,

  /**
   * @generated from enum value: NOTEBOOK_COMPUTE_PRESET_MEDIUM = 2;
   */
  NOTEBOOK_COMPUTE_PRESET_MEDIUM = 2,

  /**
   * @generated from enum value: NOTEBOOK_COMPUTE_PRESET_LARGE = 3;
   */
  NOTEBOOK_COMPUTE_PRESET_LARGE = 3,

  /**
   * @generated from enum value: NOTEBOOK_COMPUTE_PRESET_EXTRA_SMALL = 4;
   */
  NOTEBOOK_COMPUTE_PRESET_EXTRA_SMALL = 4,

  /**
   * @generated from enum value: NOTEBOOK_COMPUTE_PRESET_EXTRA_LARGE = 5;
   */
  NOTEBOOK_COMPUTE_PRESET_EXTRA_LARGE = 5,

  /**
   * @generated from enum value: NOTEBOOK_COMPUTE_PRESET_2XL = 6;
   */
  NOTEBOOK_COMPUTE_PRESET_2XL = 6,

  /**
   * @generated from enum value: NOTEBOOK_COMPUTE_PRESET_4XL = 7;
   */
  NOTEBOOK_COMPUTE_PRESET_4XL = 7,
}

/**
 * Describes the enum chalk.notebook.v1.NotebookComputePreset.
 */
export const NotebookComputePresetSchema: GenEnum<NotebookComputePreset> = /*@__PURE__*/
  enumDesc(file_chalk_notebook_v1_document, 2);

/**
 * @generated from enum chalk.notebook.v1.NotebookSQLExecutionMode
 */
export enum NotebookSQLExecutionMode {
  /**
   * @generated from enum value: NOTEBOOK_SQL_EXECUTION_MODE_UNSPECIFIED = 0;
   */
  NOTEBOOK_SQL_EXECUTION_MODE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTEBOOK_SQL_EXECUTION_MODE_SYNC = 1;
   */
  NOTEBOOK_SQL_EXECUTION_MODE_SYNC = 1,

  /**
   * @generated from enum value: NOTEBOOK_SQL_EXECUTION_MODE_IN_PROCESS_ASYNC = 2;
   */
  NOTEBOOK_SQL_EXECUTION_MODE_IN_PROCESS_ASYNC = 2,

  /**
   * @generated from enum value: NOTEBOOK_SQL_EXECUTION_MODE_ASYNC = 3;
   */
  NOTEBOOK_SQL_EXECUTION_MODE_ASYNC = 3,
}

/**
 * Describes the enum chalk.notebook.v1.NotebookSQLExecutionMode.
 */
export const NotebookSQLExecutionModeSchema: GenEnum<NotebookSQLExecutionMode> = /*@__PURE__*/
  enumDesc(file_chalk_notebook_v1_document, 3);

/**
 * @generated from enum chalk.notebook.v1.NotebookInputKind
 */
export enum NotebookInputKind {
  /**
   * @generated from enum value: NOTEBOOK_INPUT_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTEBOOK_INPUT_KIND_TEXT = 1;
   */
  TEXT = 1,

  /**
   * @generated from enum value: NOTEBOOK_INPUT_KIND_NUMBER = 2;
   */
  NUMBER = 2,

  /**
   * @generated from enum value: NOTEBOOK_INPUT_KIND_CHECKBOX = 3;
   */
  CHECKBOX = 3,

  /**
   * @generated from enum value: NOTEBOOK_INPUT_KIND_DATE = 4;
   */
  DATE = 4,

  /**
   * @generated from enum value: NOTEBOOK_INPUT_KIND_SELECT = 5;
   */
  SELECT = 5,

  /**
   * @generated from enum value: NOTEBOOK_INPUT_KIND_MULTISELECT = 6;
   */
  MULTISELECT = 6,

  /**
   * Display-only element showing one value derived from a kernel variable.
   * Never bound into the kernel (no prelude binding is emitted).
   *
   * @generated from enum value: NOTEBOOK_INPUT_KIND_SINGLE_VALUE = 7;
   */
  SINGLE_VALUE = 7,

  /**
   * Section header: a titled, collapsible grouping over the cells that
   * reference it via NotebookCell.section_id. Modeled as a cell (not a
   * NotebookCellGroup) so empty sections hold a position in the flat cell
   * order; `label` carries the title and the view state's source_collapsed
   * flag carries the collapse. Never bound into the kernel.
   *
   * @generated from enum value: NOTEBOOK_INPUT_KIND_SECTION = 8;
   */
  SECTION = 8,

  /**
   * Bool input rendered as a switch (CHECKBOX renders as a real checkbox);
   * binds exactly like CHECKBOX (checkbox_value -> bool).
   *
   * @generated from enum value: NOTEBOOK_INPUT_KIND_TOGGLE = 9;
   */
  TOGGLE = 9,

  /**
   * Legacy: table cells were briefly modeled as an input kind. Superseded by
   * the first-class NotebookTableCell body case; readers map documents with
   * this kind forward and writers never emit it.
   *
   * @generated from enum value: NOTEBOOK_INPUT_KIND_TABLE = 10;
   */
  TABLE = 10,

  /**
   * Editable literal grid: the user types the values directly into the cell
   * (unlike TABLE, which displayed an existing data source). Distinct from
   * the legacy TABLE value so old documents keep mapping forward to
   * NotebookTableCell.
   *
   * @generated from enum value: NOTEBOOK_INPUT_KIND_DATA_TABLE = 11;
   */
  DATA_TABLE = 11,
}

/**
 * Describes the enum chalk.notebook.v1.NotebookInputKind.
 */
export const NotebookInputKindSchema: GenEnum<NotebookInputKind> = /*@__PURE__*/
  enumDesc(file_chalk_notebook_v1_document, 4);

/**
 * TABLE cells: which of the table_* source field groups is authoritative.
 *
 * @generated from enum chalk.notebook.v1.NotebookTableSourceKind
 */
export enum NotebookTableSourceKind {
  /**
   * No source chosen yet; the cell renders its empty state.
   *
   * @generated from enum value: NOTEBOOK_TABLE_SOURCE_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTEBOOK_TABLE_SOURCE_KIND_VARIABLE = 1;
   */
  VARIABLE = 1,

  /**
   * @generated from enum value: NOTEBOOK_TABLE_SOURCE_KIND_DATASET = 2;
   */
  DATASET = 2,

  /**
   * @generated from enum value: NOTEBOOK_TABLE_SOURCE_KIND_SQL_TABLE = 3;
   */
  SQL_TABLE = 3,
}

/**
 * Describes the enum chalk.notebook.v1.NotebookTableSourceKind.
 */
export const NotebookTableSourceKindSchema: GenEnum<NotebookTableSourceKind> = /*@__PURE__*/
  enumDesc(file_chalk_notebook_v1_document, 5);

/**
 * SECTION cells: title typography. UNSPECIFIED = "Auto" (sized by nesting
 * depth; Heading 1 while sections do not nest).
 *
 * @generated from enum chalk.notebook.v1.NotebookSectionHeadingSize
 */
export enum NotebookSectionHeadingSize {
  /**
   * @generated from enum value: NOTEBOOK_SECTION_HEADING_SIZE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTEBOOK_SECTION_HEADING_SIZE_H1 = 1;
   */
  H1 = 1,

  /**
   * @generated from enum value: NOTEBOOK_SECTION_HEADING_SIZE_H2 = 2;
   */
  H2 = 2,

  /**
   * @generated from enum value: NOTEBOOK_SECTION_HEADING_SIZE_H3 = 3;
   */
  H3 = 3,

  /**
   * @generated from enum value: NOTEBOOK_SECTION_HEADING_SIZE_LABEL = 4;
   */
  LABEL = 4,
}

/**
 * Describes the enum chalk.notebook.v1.NotebookSectionHeadingSize.
 */
export const NotebookSectionHeadingSizeSchema: GenEnum<NotebookSectionHeadingSize> = /*@__PURE__*/
  enumDesc(file_chalk_notebook_v1_document, 6);

/**
 * SINGLE_VALUE: how the element picks its value out of a dataframe variable.
 *
 * @generated from enum chalk.notebook.v1.NotebookSingleValueSelector
 */
export enum NotebookSingleValueSelector {
  /**
   * Legacy/unset; treated as ROW.
   *
   * @generated from enum value: NOTEBOOK_SINGLE_VALUE_SELECTOR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTEBOOK_SINGLE_VALUE_SELECTOR_ROW = 1;
   */
  ROW = 1,

  /**
   * @generated from enum value: NOTEBOOK_SINGLE_VALUE_SELECTOR_AGGREGATE = 2;
   */
  AGGREGATE = 2,
}

/**
 * Describes the enum chalk.notebook.v1.NotebookSingleValueSelector.
 */
export const NotebookSingleValueSelectorSchema: GenEnum<NotebookSingleValueSelector> = /*@__PURE__*/
  enumDesc(file_chalk_notebook_v1_document, 7);

/**
 * SINGLE_VALUE: how a dataframe column reduces to one value.
 *
 * @generated from enum chalk.notebook.v1.NotebookSingleValueAggregation
 */
export enum NotebookSingleValueAggregation {
  /**
   * @generated from enum value: NOTEBOOK_SINGLE_VALUE_AGGREGATION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTEBOOK_SINGLE_VALUE_AGGREGATION_MIN = 1;
   */
  MIN = 1,

  /**
   * @generated from enum value: NOTEBOOK_SINGLE_VALUE_AGGREGATION_MAX = 2;
   */
  MAX = 2,

  /**
   * @generated from enum value: NOTEBOOK_SINGLE_VALUE_AGGREGATION_MEAN = 3;
   */
  MEAN = 3,

  /**
   * @generated from enum value: NOTEBOOK_SINGLE_VALUE_AGGREGATION_SUM = 4;
   */
  SUM = 4,

  /**
   * @generated from enum value: NOTEBOOK_SINGLE_VALUE_AGGREGATION_MEDIAN = 5;
   */
  MEDIAN = 5,

  /**
   * @generated from enum value: NOTEBOOK_SINGLE_VALUE_AGGREGATION_COUNT = 6;
   */
  COUNT = 6,

  /**
   * @generated from enum value: NOTEBOOK_SINGLE_VALUE_AGGREGATION_COUNT_DISTINCT = 7;
   */
  COUNT_DISTINCT = 7,

  /**
   * Rank carried in single_value_percentile, so the wire format does not need a
   * new enum member per percentile the product decides to offer. MEDIAN predates
   * this and stays the canonical spelling of p50.
   *
   * @generated from enum value: NOTEBOOK_SINGLE_VALUE_AGGREGATION_PERCENTILE = 8;
   */
  PERCENTILE = 8,

  /**
   * Population standard deviation.
   *
   * @generated from enum value: NOTEBOOK_SINGLE_VALUE_AGGREGATION_STDDEV = 9;
   */
  STDDEV = 9,
}

/**
 * Describes the enum chalk.notebook.v1.NotebookSingleValueAggregation.
 */
export const NotebookSingleValueAggregationSchema: GenEnum<NotebookSingleValueAggregation> = /*@__PURE__*/
  enumDesc(file_chalk_notebook_v1_document, 8);

/**
 * How SELECT/MULTISELECT choices are sourced.
 *
 * @generated from enum chalk.notebook.v1.NotebookInputValuesMode
 */
export enum NotebookInputValuesMode {
  /**
   * Legacy documents predate this field; treated as STATIC.
   *
   * @generated from enum value: NOTEBOOK_INPUT_VALUES_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTEBOOK_INPUT_VALUES_MODE_STATIC = 1;
   */
  STATIC = 1,

  /**
   * @generated from enum value: NOTEBOOK_INPUT_VALUES_MODE_DYNAMIC = 2;
   */
  DYNAMIC = 2,
}

/**
 * Describes the enum chalk.notebook.v1.NotebookInputValuesMode.
 */
export const NotebookInputValuesModeSchema: GenEnum<NotebookInputValuesMode> = /*@__PURE__*/
  enumDesc(file_chalk_notebook_v1_document, 9);

/**
 * @generated from enum chalk.notebook.v1.NotebookCellGroupKind
 */
export enum NotebookCellGroupKind {
  /**
   * @generated from enum value: NOTEBOOK_CELL_GROUP_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Members lay out side by side in one horizontal row.
   *
   * @generated from enum value: NOTEBOOK_CELL_GROUP_KIND_ROW = 1;
   */
  ROW = 1,
}

/**
 * Describes the enum chalk.notebook.v1.NotebookCellGroupKind.
 */
export const NotebookCellGroupKindSchema: GenEnum<NotebookCellGroupKind> = /*@__PURE__*/
  enumDesc(file_chalk_notebook_v1_document, 10);

/**
 * Where a listed notebook secret comes from. GRANTED entries are read-only
 * through the notebook surface: they are injected into runs but cannot be
 * edited, deleted, or have their value read via the notebook secret RPCs
 * (manage them from the environment secrets page instead). A notebook-owned
 * secret with the same name shadows a granted one at runtime.
 *
 * @generated from enum chalk.notebook.v1.NotebookSecretOrigin
 */
export enum NotebookSecretOrigin {
  /**
   * @generated from enum value: NOTEBOOK_SECRET_ORIGIN_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Owned by the notebook's scope.
   *
   * @generated from enum value: NOTEBOOK_SECRET_ORIGIN_OWN = 1;
   */
  OWN = 1,

  /**
   * An environment-wide secret granted to the notebook's scope by reference.
   *
   * @generated from enum value: NOTEBOOK_SECRET_ORIGIN_GRANTED = 2;
   */
  GRANTED = 2,
}

/**
 * Describes the enum chalk.notebook.v1.NotebookSecretOrigin.
 */
export const NotebookSecretOriginSchema: GenEnum<NotebookSecretOrigin> = /*@__PURE__*/
  enumDesc(file_chalk_notebook_v1_document, 11);

